<span [ngClass]="customCssClass || 'text-body-s'"><ng-content></ng-content></span>
